import Vue from 'vue'
Vue.directive('color', {
    bind(el, binding) {
        const themeColor = getComputedStyle(document.body)
            .getPropertyValue('--tc');
        let splitArr = binding.expression.replace(/\"|\'/g, '').split(' ');
        splitArr.forEach(v => {
            if (v === 'border') {
                el.style[v] = `1px solid ${themeColor}`
            } else {
                el.style[v] = themeColor;
            }
        })
    },
    update(el, binding) {
        let themeColor = getComputedStyle(document.body)
            .getPropertyValue('--tc');
        let splitArr = binding.expression.replace(/\"|\'/, '').split(' ');
        splitArr.forEach(v => {
            if (v === 'border') {
                el.style[v] = `1px solid ${themeColor}`
            } else {
                el.style[v] = themeColor;
            }
        })
    }
})

Vue.directive('longpress', {
    bind: function(el, binding, vNode) {
        if (typeof binding.value !== 'function') {
            throw 'callback must be a function'
        }
        // 定义变量
        let pressTimer = null
        // 创建计时器（ 2秒后执行函数 ）
        let start = (e) => {
            if (e.type === 'click' && e.button !== 0) {
                return
            }
            if (pressTimer === null) {
                pressTimer = setTimeout(() => {
                    handler()
                }, 2000)
            }
        }
        // 取消计时器
        let cancel = (e) => {
            if (pressTimer !== null) {
                clearTimeout(pressTimer)
                pressTimer = null
            }
        }
        // 运行函数
        const handler = (e) => {
            binding.value(e)
        }
        // 添加事件监听器
        el.addEventListener('mousedown', start)
        el.addEventListener('touchstart', start)
        // 取消计时器
        el.addEventListener('click', cancel)
        el.addEventListener('mouseout', cancel)
        el.addEventListener('touchend', cancel)
        el.addEventListener('touchcancel', cancel)
    },
    // 当传进来的值更新的时候触发
    componentUpdated(el, { value }) {
        el.$value = value
    },
    // 指令与元素解绑的时候，移除事件绑定
    unbind(el) {
        el.removeEventListener('click', el.handler)
    },
})


Vue.directive('draggable', {
    inserted: function(el) {
        el.style.cursor = 'move'
        el.onmousedown = function(e) {
            let disx = e.pageX - el.offsetLeft
            let disy = e.pageY - el.offsetTop
            document.onmousemove = function(e) {
                let x = e.pageX - disx
                let y = e.pageY - disy
                let maxX = document.body.clientWidth - parseInt(window.getComputedStyle(el).width)
                let maxY = document.body.clientHeight - parseInt(window.getComputedStyle(el).height)
                if (x < 0) {
                    x = 0
                } else if (x > maxX) {
                    x = maxX
                }

                if (y < 0) {
                    y = 0
                } else if (y > maxY) {
                    y = maxY
                }

                el.style.left = x + 'px'
                el.style.top = y + 'px'
            }
            document.onmouseup = function() {
                document.onmousemove = document.onmouseup = null
            }
        }
    },
})